import { render, staticRenderFns } from "./AssignPlaylistModal.vue?vue&type=template&id=22a4454c&"
import script from "./AssignPlaylistModal.vue?vue&type=script&lang=js&"
export * from "./AssignPlaylistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QBtn,QCardSection,QExpansionItem,QItemSection,QIcon,QCheckbox,QTooltip,QItem,QItemLabel,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QBtn,QCardSection,QExpansionItem,QItemSection,QIcon,QCheckbox,QTooltip,QItem,QItemLabel,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
